export default "__VITE_ASSET__Duw2O99L__"